import { render } from "./DownLoadApply.vue?vue&type=template&id=d30b9124&scoped=true"
import script from "./DownLoadApply.vue?vue&type=script&lang=js"
export * from "./DownLoadApply.vue?vue&type=script&lang=js"

import "./DownLoadApply.vue?vue&type=style&index=0&id=d30b9124&scoped=true&lang=css"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d30b9124"]])

export default __exports__